module.exports = __webpack_public_path__ + "static/media/placeholder2.29500207.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/placeholder2.jpg
// module id = 624
// module chunks = 0